import { render } from "./SidebarView.vue?vue&type=template&id=aeb28108&ts=true"
import script from "./SidebarView.vue?vue&type=script&lang=ts"
export * from "./SidebarView.vue?vue&type=script&lang=ts"

import "./SidebarView.vue?vue&type=style&index=0&id=aeb28108&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__